import { Injectable } from '@angular/core';
import firebase from 'firebase/compat/app';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FirebaseDatabaseService {
  private dbCallsRef = firebase.database().ref('/tripmeld/calls');
  private dbClientsRef = firebase.database().ref('/tripmeld/clients');
  private dbUserRef = firebase.database().ref(`/users/${localStorage.getItem("jti")}`);
  private dbTaskRemindersUserRef = firebase.database().ref(`/taskreminders/${localStorage.getItem("jti")}`);

  constructor() { }

  subscribeToCallsEvent(): Observable<any> {
    return new Observable(observer => {
      this.dbCallsRef.on('value', (snapshot) => {
        observer.next(snapshot.val());
      }, (error) => {
        observer.error(error);
      });
    });
  }

  subscribeToClientsEvent(): Observable<any> {
    return new Observable(observer => {
      this.dbClientsRef.on('value', (snapshot) => {
        observer.next(snapshot.val());
      }, (error) => {
        observer.error(error);
      });
    });
  }

  subscribeToUsersEvent(): Observable<any> {
    return new Observable(observer => {
      this.dbUserRef.on('value', (snapshot) => {
        observer.next(snapshot.val());
      }, (error) => {
        observer.error(error);
      });
    });
  }

  subscribeToTaskRemindersUsersEvent(): Observable<any> {
    return new Observable(observer => {
      this.dbTaskRemindersUserRef.on('value', (snapshot) => {
        observer.next(snapshot.val());
      }, (error) => {
        observer.error(error);
      });
    });
  }
}
